import React from "react";
import { Routes, Route } from "react-router-dom";
import Loading from "components/spinner"; // Loading spinner

// Import hook normally (no lazy loading for hooks)
import useMatomoPageTracking from "hooks/useMatomoPageTracking";

// Lazy load all components
const Contact = React.lazy(() => import("pages/Contact"));
const About = React.lazy(() => import("pages/About"));
const ITA = React.lazy(() => import("pages/ITA"));
const NotFound = React.lazy(() => import("pages/NotFound"));
const Header = React.lazy(() => import("components/Header"));
const Duty = React.lazy(() => import("pages/CalculatorResults/Duty"));
const Paye = React.lazy(() => import("pages/CalculatorResults/Paye"));
const FAQ = React.lazy(() => import("pages/FAQ"));
const Download = React.lazy(() => import("pages/Downlod"));
const AllRates = React.lazy(() => import("pages/AllRates"));
const PressRelease = React.lazy(() => import("pages/PressRelease"));
const Event = React.lazy(() => import("pages/Events"));
const Article = React.lazy(() => import("pages/Article"));
const IncentivesForTourism = React.lazy(() => import("pages/IncentivesForTourism"));
const ArticlePage = React.lazy(() => import("pages/Articles"));
const EventPage = React.lazy(() => import("pages/Envents1"));
const Tenders = React.lazy(() => import("pages/Tenders"));
const NewsArchive = React.lazy(() => import("pages/NewsArchive"));
const EPayments = React.lazy(() => import("pages/EPayments"));
const PressReleases = React.lazy(() => import("pages/PressReleases"));
const Terms = React.lazy(() => import("pages/Terms"));
const CallCenter = React.lazy(() => import("pages/CallCenter"));
const Custom = React.lazy(() => import("pages/Custom/Index"));
const Form12 = React.lazy(() => import("pages/Form12Results/Form12"));
const Employees = React.lazy(() => import("pages/Employees"));
const BoardMembers = React.lazy(() => import("pages/BoardMembers"));
const Applications = React.lazy(() => import("pages/Applications"));
const MediaCenter = React.lazy(() => import("pages/MediaCenter"));
const ApplicationExpanded = React.lazy(() => import("pages/Application"));
const Publications = React.lazy(() => import("pages/Publications/Publications"));
const Statistics = React.lazy(() => import("pages/Statistics"));

const Eguides = React.lazy(() => import("pages/Eguides"));
const NavTest = React.lazy(() => import("pages/NavTest/NavTest"));

// Lazy load dynamic routes
const MRAtv = React.lazy(() => import("pages/MRAtv"));
const LTOGetStarted = React.lazy(() => import("pages/LTOGetStarted"));
const LTO = React.lazy(() => import("pages/LTO"));
const News = React.lazy(() => import("pages/News"));
const NewsExpanded = React.lazy(() => import("pages/NewsExpanded"));
const Home1 = React.lazy(() => import("pages/Home1"));
const Search = React.lazy(() => import("pages/Search"));
const Test = React.lazy(() => import("pages/Test"));
const AnonymousTipsForm = React.lazy( () => import("pages/AnonymousTipsForm"));
const ApprovedPOSVendors = React.lazy(() => import("pages/ApprovedPOSVendors"));

const ProjectRoutes = () => {
  useMatomoPageTracking(); // use the hook normally here
  return (
    <React.Suspense fallback={<Loading />}>
      <Header />
      <Routes>
        <Route path="/" element={<Home1 />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/custom-downloads" element={<Custom />} />
        <Route path="/newsexpanded/:slug" element={<NewsExpanded />} />
        <Route path="/news" element={<News />} />
        <Route path="/articles" element={<ArticlePage />} />
        <Route path="/events" element={<EventPage />} />
        <Route path="/:slug" element={<LTO />} />
        <Route path="/view/:slug" element={<LTOGetStarted />} />
        <Route path="/mratv" element={<MRAtv />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/duty" element={<Duty />} />
        <Route path="/paye" element={<Paye />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/search" element={<Search />} />
        <Route path="/allrates" element={<AllRates />} />
        <Route path="/domestic-downloads" element={<Download />} />
        <Route path="/institute-of-tax-administration" element={<ITA />} />
        <Route path="/press/:slug" element={<PressRelease />} />
        <Route path="/press" element={<PressReleases />} />
        <Route path="/events/:slug" element={<Event />} />
        <Route path="/projects/:slug" element={<Event />} />
        <Route path="/articles/:slug" element={<Article />} />
        <Route path="/news/archives" element={<NewsArchive />} />
        <Route path="/epayments" element={<EPayments />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/callcenter" element={<CallCenter />} />
        <Route path="/form12-validation" element={<Form12 />} />
        <Route path="/top-management" element={<Employees />} />
        <Route path="/board-members" element={<BoardMembers />} />
        <Route path="/view/board-members" element={<BoardMembers />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/media-center" element={<MediaCenter />} />
        <Route path="/applications/:slug" element={<ApplicationExpanded />} />
        <Route path="/customs-and-excise-incentives-for-tourism" element={<IncentivesForTourism />} />
        <Route path="/tenders" element={<Tenders />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/e-guides" element={<Eguides />} />
        <Route path="/navigation" element={<NavTest />} />
        <Route path="/test" element={<Test />} />
        <Route path="/anonymous-tips" element={<AnonymousTipsForm />} />
        <Route path="/approved-vendors" element={<ApprovedPOSVendors/>}/>
      </Routes>
    </React.Suspense>
  );
};

export default ProjectRoutes;
